export const OPEN_MODAL = "openModal";
export const CLOSE_MODAL = "closeModal";
export const SET_CURRENT_RECIPE_ID = "setCurrentRecipeId";
